export const SN_ORDER = 'order'
export const ORDER_LIST_UPDATED = SN_ORDER + '/LIST_UPDATED'
export const ORDER_SELECTED_ITEMS_UPDATED = SN_ORDER + '/SELECTED_ITEMS_UPDATED'
export const ORDER_QUERY_UPDATED = SN_ORDER + '/QUERY_UPDATED'
export const ORDER_PRDT_IN_PRCS_UPDATED = SN_ORDER + '/PRDT_IN_PRCS_UPDATED'
export const ORDER_ADD_TO_PRDT_IN_PRCS_BULK = SN_ORDER + '/ADD_TO_PRDT_IN_PRCS_BULK'
export const ORDER_LST_ACTN_TIMESTAMP_UPDATED = SN_ORDER + '/LST_ACTN_TIMESTAMP_UPDATED'
export const ORDER_BRKRNG_CNT_BY_PRDCT_UPDATED = SN_ORDER + '/BRKRNG_CNT_BY_PRDCT_UPDATED'